import configuration from '../configuration';

export default (name) => {
  const {suffix} = configuration();
  return new RegExp(`${name}${suffix || ''}$`);
};
